import React, { useState } from 'react';

const accordionData = [
  {
    title: "¿Qué tecnología avanzada usan en las cirugías?",
    content:
      "En WM Clinic, empleamos laparoscopia 4K, navegación quirúrgica y sistemas de monitoreo avanzados para mayor precisión y seguridad.",
  },
  {
    title: "¿Qué preparación necesito antes de un procedimiento quirúrgico?",
    content:
      "Una vez agendado su procedimiento, nuestro equipo médico le proporcionará instrucciones detalladas y personalizadas.",
  },
  {
    title: "¿Cómo es la recuperación post-quirúrgica en la clínica?",
    content:
      "La recuperación varía por el tipo de cirugía. Le daremos pautas completas para manejo del dolor, cuidados y rehabilitación.",
  },
  {
    title: "¿Ofrecen opciones de financiamiento o trabajan con seguros?",
    content:
      "Contáctenos para conocer nuestras opciones de pago y acuerdos con aseguradoras.",
  },
  {
    title: "Tras la cirugía, ¿Será necesario asistir a un centro de masajes?",
    content:
      "No. Nuestra clínica cuenta con su propio centro estético para cuidados post operatorios. ",
  },
];

const FaqSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    }

    return (
        <section className="wpo-faq-section section-padding">
            <div className="container mt-5">
                <div className="row align-items-center">
                    <div className="col-lg-8 offset-lg-2">
                        <div className="section_title">
                            <h3>Preguntas frecuentes</h3>
                        </div>
                    </div>
                    <div className="col-lg-8 offset-lg-2">
                        <div className="wpo-faq-wrap">
                            <div className="row">
                                <div className="col-lg-12 col-12">
                                    <div className="wpo-benefits-item">
                                        {accordionData.map((accordion, index) => (
                                            <div
                                                className={`accordion-item ${activeIndex === index ? 'active' : ''}`}
                                                key={index}
                                            >
                                                <h3 className="accordion-header">
                                                    <button onClick={() => handleToggle(index)}>
                                                        {accordion.title}
                                                    </button>
                                                </h3>
                                                {activeIndex === index && (
                                                    <div className="accordion-body">
                                                        <p className='text-black'>{accordion.content}</p>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
